if (!customElements.get("count-down")) {
  class Countdown extends HTMLElement {
    connectedCallback() {
      this.expiryISO = this.getAttribute("data-expiry");

      if (!this.expiryISO) {
        console.error("countdown: Required attributes not found");
        return;
      }

      this.expiryDate = new Date(this.expiryISO);
      const difference = this.expiryDate - new Date();
      this.differenceInDays = Math.floor(difference / (1000 * 60 * 60 * 24));
      this.differenceInHours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

      this.daysSpan = this.querySelector(".js-days");
      this.hoursSpan = this.querySelector(".js-hours");

      if (this.daysSpan) {
        this.daysSpan.textContent = this.differenceInDays;
      }

      if (this.hoursSpan) {
        this.hoursSpan.textContent = this.differenceInHours;
      }
    }
  }

  customElements.define("count-down", Countdown);
}
